import { Mobile, iOS } from './core'
import fullpage from 'fullpage.js'

function isSafariOnMac() {
  let userAgent = navigator.userAgent.toLowerCase(),
  isSafari = userAgent.indexOf('safari') !== -1,
  isMac = userAgent.indexOf('mac') !== -1,
  isChrome = userAgent.indexOf('chrome') !== -1
  return isSafari && isMac && !isChrome;
}

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  let skipTimeout = undefined,
  flashTimeout = undefined,
  videoTimeout = undefined

  var fp = $('#fullpage').fullpage({
    licenseKey: '1MIPI-Y24I9-RHW2I-9DP68-RNCJN',
		autoScrolling: true,
    scrollingSpeed: 1,
    sectionSelector: '.page-section',
    credits: {
      enabled: false,
    },
    onLeave: function(origin, destination, direction, trigger) {
      /* Skip gallery images quick */
      clearTimeout(skipTimeout)
      if (direction == 'down' && $(destination.item).hasClass('gallery')) {
        skipTimeout = setTimeout(fullpage_api.moveSectionDown, 833) // 50 frames
      }

      /* Head shows logo */
      if ($(destination.item).hasClass('head')) {
        $('.brand').addClass('brand--visible')
        $('.arrow-down').addClass('arrow-down--visible')
      } else {
        $('.brand').removeClass('brand--visible')
        $('.arrow-down').removeClass('arrow-down--visible')
      }

      /* Head shows lang switcher */
      if ($(destination.item).hasClass('flash-section') || $(destination.item).hasClass('gallery')) {
        $('.lang-switcher').removeClass('lang-switcher--visible')
      } else {
        $('.lang-switcher').addClass('lang-switcher--visible')
      }

      /* Remove origin */
      if (flash_animation != undefined) {
        flash_animation.removeEventListener('complete')
      }
      if (flash_video != undefined) {
        flash_video.off('ended')
      }
      clearTimeout(videoTimeout)
      clearTimeout(flashTimeout)
      if ($(origin.item).hasClass('flash-section')) {
        setTimeout(function() {
          $(origin.item).remove()
          fullpage_api.reBuild()
        }, 100)
      }

      /* Remove previous galleries */
      if (direction == 'up' && !$(origin.item).hasClass('gallery') && $(destination.item).hasClass('gallery')) {
        let destinationIndex = destination.index - 2;
        setTimeout(function(){
          fullpage_api.moveTo(destinationIndex);
        })
      }

      /* Check overflow */
      checkOverflow()
    }
	});

  /* Animation */
  let flash_animation = undefined,
  flash_video = undefined
  if ($('body').hasClass('site-grandbal') && (!$.mlmi.mobile.isMobile && (iOS() || isSafariOnMac()))) {
    var flash_section = $('.flash-section'),
    flash_intro = $('.flash-intro')
    flash_video = $('<video>').attr('preload', 'auto').addClass('flash-video')
    let source = $('<source>').attr('type', 'video/mp4')
    source.attr('src', ($('body').hasClass('language-en') ? '..' : '.') + '/img/animation/GrandBal_animation_siteweb_3840x2016.mp4')
    flash_video.on('ended', function() {
      flashTimeout = setTimeout(function() {
        fullpage_api.moveSectionDown()
      }, 150)
    })
    videoTimeout = setTimeout(function() {
      if (flash_video.get(0).paused) {
        fullpage_api.moveSectionDown()
      }
    }, 3500)
    flash_video.prop('autoplay', true)
    flash_video.prop('muted', true)
    flash_video.prop('controls', false)
    flash_video.attr('playsinline', 'playsinline')
    flash_video.attr('webkit-playsinline', 'webkit-playsinline')
    flash_video.append(source)
    flash_intro.remove()
    flash_section.append(flash_video)
  } else {
    var flash_section = $('.flash-section'),
    flash_intro = $('.flash-intro')
    function flashAnimation() {
      if (flash_animation != undefined) {
        flash_animation.goToAndStop(1)
        flash_intro.empty()
      }
      let animationPath = ($('body').hasClass('language-en') ? '..' : '.') + '/img/animation/McCord_grandbal_invitation_' + ($.mlmi.mobile.isMobile ? 'mobile' : 'desktop') + '.json'
      if ($('body').hasClass('site-balsucre')) {
        animationPath = ($('body').hasClass('language-en') ? '..' : '.') + '/img/animation/McCord_balsucre_invitation_' + ($.mlmi.mobile.isMobile ? 'mobile' : 'desktop') + '_' + ($('body').hasClass('language-en') ? 'EN' : 'FR') + '.json'
      }
      flash_animation = bodymovin.loadAnimation({
        container: flash_intro.get(0),
        renderer: 'svg',
        autoplay: false,
        loop: false,
        path: animationPath,
      })
      flash_animation.setSubframe(false)
      flash_animation.addEventListener('data_ready', function() {
        if ($('body').hasClass('fp-viewing-0')) {
          flash_animation.goToAndPlay(1, true)
        }
      })
      flash_animation.addEventListener('complete', function(e) {
        flashTimeout = setTimeout(function() {
          fullpage_api.moveSectionDown()
        }, 150)
      })
    }
    $.mlmi.mobile.addCallbacks(flashAnimation, flashAnimation)
  }

  $('.arrow-down').on('click', function() {
    fullpage_api.moveSectionDown()
  })

  /* Button effect */
  function checkMobile() {
    checkLogo()
    $('.btn-primary').each(function() {
      $(this).attr('style', '')
      $(this).css({
        'width': $(this).outerWidth() + 'px',
        'padding-left': 0,
        'padding-right': 0,
      })
    })
  }
  $.mlmi.mobile.addCallbacks(checkMobile, checkMobile)

  /* Logo position */
  var logoTimeout = undefined
  function checkLogo() {
    clearTimeout(logoTimeout)
    var h1Position = 21
    logoTimeout = setTimeout(function() {
      if (!$.mlmi.mobile.isMobile) {
        let headHeight = $('.page-section.head').outerHeight(false),
        h1Height = $('.page-section.head .container').outerHeight(false),
        h1FontSize = parseFloat($('h1').css('font-size'))
        h1Position = Math.round(((headHeight - h1Height) / 2) + (h1FontSize * .2))
      }
      $('body').css('--h1pos', h1Position + 'px')
    }, 800)
  }
  $(window).on('resize orientationchange load', checkLogo)
  checkLogo()

  /* Maybe overflow */
  function checkOverflow() {
    setTimeout(function() {
      $('.maybe-overflow').each(function() {
        let section = $(this)
        if (section.find('.container').outerHeight(false) < section.outerHeight(false) - 60) {
          section.find('.fp-overflow').addClass('vertical-center')
        } else {
          section.find('.fp-overflow').removeClass('vertical-center')
        }
      })
    }, 800)
  }
  $(window).on('resize orientationchange load', checkOverflow)
  checkOverflow()

  /* Overflow language */
  setInterval(function() {
    if ($('.active').hasClass('maybe-overflow') && $('.active .fp-overflow').scrollTop() > 10) {
      $('.lang-switcher').addClass('lang-switcher--scrolled')
    } else {
      $('.lang-switcher').removeClass('lang-switcher--scrolled')
    }
  }, 100)
})
